class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

renderContents(parsedState) {
  const isMultiple = Array.isArray(parsedState.items);
  if (!isMultiple) this.cartItemKey = parsedState.key;

  this.getSectionsToRender().forEach((section => {
    const sectionHtml = parsedState.sections?.[section.id];
    if (!sectionHtml) return;

    if (section.id === 'cart-notification-product' && isMultiple) {
      const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      
      parsedState.items.forEach(item => {
        const key = item.key;
        
        const escapedId = CSS.escape(`cart-notification-product-${key}`);
        const newEl = doc.querySelector(`#${escapedId}`);
        const existingEl = document.getElementById(`cart-notification-product-${key}`);
       
        /*--- remove old content ---- */
        const currentKeys = parsedState.items.map(item => `cart-notification-product-${item.key}`);
        const container = document.getElementById('cart-notification-product');
        
        if (container) {
            Array.from(container.children).forEach(child => {
            if (!currentKeys.includes(child.id)) {
            container.removeChild(child);
            }
            });
        }
        /*=== end ===*/
        
        if (newEl && existingEl) {
          existingEl.innerHTML = newEl.innerHTML;
        } else if (newEl && !existingEl) {
          const container = document.getElementById('cart-notification-product');
          if (container) container.appendChild(newEl);
        }
      });
    } else {
      const targetEl = document.getElementById(section.id);
      if (!targetEl) return;
      targetEl.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
    }
  }));

 this.updateProgressBar();


  if (this.header) this.header.reveal();
  this.open();
}

updateProgressBar() {
  if(document.querySelectorAll('#notification__progress_bar .discount_progress_bar').length > 0){
    const barContainer = document.querySelector('#notification__progress_bar .discount_progress_bar');
    if (!barContainer) return;
     
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const progressBar = barContainer.querySelector('.progress__bar_fill');
        const progressText = barContainer.querySelector('.progress__text');
        if (!progressBar || !progressText) return;

        if (cart.discount_codes.length > 0) {
          const appliedCode = cart.discount_codes[0].code.toLowerCase();
          if (appliedCode !== 'freethreshold10') {
            barContainer.style.display = 'none'; // hide
            return;
          }
       }

       barContainer.style.display = '';
    
        const minAmount = parseInt(barContainer.dataset.amount, 10);
        const cartTotal = cart.original_total_price; 

        let percent = Math.min(100, Math.floor((cartTotal / minAmount) * 100));
        progressBar.style.width = percent + '%';

        if (cartTotal < minAmount) {
          const remaining = minAmount - cartTotal;
          progressText.innerHTML = `Add <span class="remaining_amount">${(remaining/100).toLocaleString(undefined, { 
            style: 'currency', currency: window.Shopify.currency.active 
          })}</span> more to unlock <span class="percentage_v">10%</span> off.`;
        } else {
          progressText.innerHTML = `You have unlocked a <span class="percentage_v">10%</span> off!`;
        }
      });
    }
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'notification__progress_bar',
        selector: '#notification__progress_bar'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
